import { render, staticRenderFns } from "./leaveManage.vue?vue&type=template&id=fdd796be&"
import script from "./leaveManage.vue?vue&type=script&lang=js&"
export * from "./leaveManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports